export default __webpack_public_path__ + "static/media/black-parking-clock.261f8e83.png";